import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchBenchmarks = createAsyncThunk(
  'benchmarks/fetchBenchmarks',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/benchmarks`, {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching benchmarks');
    }
  }
); 